import { Product, SkeletonProduct } from "../../types/types";

export const getProductKey = (product: Product | SkeletonProduct): string => {
  const variantId =
    product.__typename !== "SkeletonProduct" && product.initialVariantId
      ? "-" + product.initialVariantId
      : "";
  const sponsoredStatus =
    product.__typename !== "SkeletonProduct" && product.advertising
      ? "sponsored"
      : "standard";
  return `${product.aliases.pimProductId}${variantId}-${sponsoredStatus}`;
};
